import type { Deal, KillReason, LostToLenderDetails } from "../types/deal";
import { sanitizeLostToLenderDetailsForPut } from "./dealStatusHelpers";

export type DealPutPatches = {
  kill_reason?: KillReason | null | undefined;
  lost_to_lender_details?: LostToLenderDetails | null | undefined;
};

export function prepareDealPutPayload(
  deal: Deal,
  patches?: DealPutPatches,
): Omit<Deal, "id"> {
  const next: Deal = { ...deal };

  if (patches && "kill_reason" in patches) {
    next.kill_reason = patches.kill_reason ?? undefined;
  }

  if (patches && "lost_to_lender_details" in patches) {
    next.lost_to_lender_details = patches.lost_to_lender_details
      ? sanitizeLostToLenderDetailsForPut(patches.lost_to_lender_details)
      : undefined;
  }

  const { id: _id, ...payload } = next;

  const sourceEntity = (payload as any).source_entity;
  if (
    sourceEntity &&
    typeof sourceEntity === "object" &&
    typeof sourceEntity.id === "number"
  ) {
    (payload as any).source_id = sourceEntity.id;
    delete (payload as any).source_entity;
    delete (payload as any).source;
  }

  const nda = (payload as any).nda;
  if (nda && typeof nda === "object" && typeof nda.id === "number") {
    (payload as any).nda = { id: nda.id };
    (payload as any).nda_id = nda.id;
  } else if (typeof (payload as any).nda_id === "number") {
    (payload as any).nda = { id: (payload as any).nda_id };
  } else if (nda === null || (payload as any).nda_id === null) {
    (payload as any).nda = null;
    (payload as any).nda_id = null;
  } else if (nda && typeof nda === "object" && typeof nda.id !== "number") {
    // Extraction draft without id — do not send on deal put.
    delete (payload as any).nda;
    delete (payload as any).nda_id;
  }

  return payload;
}
